module.exports = __webpack_public_path__ + "static/media/Dominica - DM.bb5d91ed.png";